var _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReminderDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "603.77 361.88 603.77 393.08 649.39 393.08 699.71 393.08 699.71 361.88 603.77 361.88",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "599.75 353.16 599.75 361.88 703.06 361.88 703.06 353.16 649.39 353.16 599.75 353.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "651.4 393.08 699.71 393.08 699.71 361.88 703.06 361.88 703.06 353.16 649.39 353.16 649.39 361.07 651.4 393.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.19,
    y: 366.91,
    width: 19.45,
    height: 4.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 614.69,
    y: 377.48,
    width: 24.98,
    height: 9.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.12,460.13l-2-427.24h-8.27V117H682.46l-.4-84.14h-8.27V117h-73.5l-.4-84.14h-8.27V117H570.31l-.39-84.14h-8.27V460.13h10.28l-.27-57.33h20v57.33h10.29l-.27-57.33h72.15v57.33h10.29l-.27-57.33h20v57.33Zm-133-113.95-7.39-31.67h15.17Zm10.52-29.73v74.81l-9-38.37Zm0-108.73-9-38.37,9-36.44Zm-1.6,6.87H571.55L581,176Zm-8.92-52-8.47-36.27H590Zm-1.64,6.69-8.73,35.51-.35-74.4Zm-8.2,148.44,8.2,35.1-7.88,32.06ZM581,359.59l7.91,33.87H572.7Zm-9.49-54.41-.07-.29-.26.06-.38-81h20.8v81.26Zm29.26-81.26h73v81.26H601.18ZM692.65,176l9,38.55H683.18Zm-9.78,26.74-.33-70.09,8.55,36.64Zm21,7.41-9.53-40.84,9.53-38.79Zm0,4.26v.14h-.58Zm0,104.22v70.25l-8.41-36Zm-10,27.51-7.4-31.67h15.18Zm-1.13-183.54-8.47-36.27h17.38Zm11.1,61.28v81.26H684.29l-.07-.29-.87.2L683,223.92Zm-11.62,129-8.47,34.48-.34-72.24Zm1.57,6.72,7.9,33.87H685.45Zm-20-233.22v88.22h-73l-.42-88.22ZM602.91,393.46h-1.32l-.37-78.95h72.57v78.95Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.72,
    y: 151.27,
    width: 13.66,
    height: 63.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.54,199.68a2.71,2.71,0,1,1-2.71-2.71A2.7,2.7,0,0,1,663.54,199.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.62,
    y: 168.14,
    width: 4.18,
    height: 26.03,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.84,
    y: 151.27,
    width: 13.66,
    height: 63.68,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.66,199.68A2.71,2.71,0,1,1,647,197,2.71,2.71,0,0,1,649.66,199.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 644.74,
    y: 168.14,
    width: 4.18,
    height: 26.03,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.63,
    y: 151.27,
    width: 13.66,
    height: 63.68,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.44,199.68a2.71,2.71,0,1,1-2.71-2.71A2.7,2.7,0,0,1,636.44,199.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.53,
    y: 168.14,
    width: 4.18,
    height: 26.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "609.73 213.99 626.15 157.96 620.49 155.48 603.65 211.96 609.73 213.99",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "585.4 305.18 585.4 295.54 653.51 295.54 653.72 305.18 585.4 305.18",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.54,297.11s-60.4.44-64.31,1.37c-.84.19-1.7,3.9,0,4.24s64.31.85,64.31.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "593.32 295.15 593.32 285.51 647.26 285.51 647.44 295.15 593.32 295.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.29,287.09s-47.85.44-50.94,1.36c-.67.2-1.35,3.91,0,4.25s50.94.85,50.94.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "593.07 285.63 593.07 275.99 647.02 275.99 647.19 285.63 593.07 285.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.05,277.56s-47.85.44-50.94,1.37c-.67.19-1.35,3.9,0,4.24s50.94.85,50.94.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.85,
    y: 54.58,
    width: 13.67,
    height: 63.68,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.67,103a2.71,2.71,0,1,1-2.71-2.71A2.7,2.7,0,0,1,669.67,103Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.76,
    y: 71.45,
    width: 4.18,
    height: 26.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 645.98,
    y: 54.58,
    width: 13.66,
    height: 63.68,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.79,103a2.71,2.71,0,1,1-2.71-2.71A2.7,2.7,0,0,1,655.79,103Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650.88,
    y: 71.45,
    width: 4.18,
    height: 26.03,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.76,
    y: 54.58,
    width: 13.66,
    height: 63.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.57,103a2.71,2.71,0,1,1-2.71-2.71A2.7,2.7,0,0,1,642.57,103Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.66,
    y: 71.45,
    width: 4.18,
    height: 26.03,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.68,418.2v23.47h-3.92v2.54h3.92v15.71h73.23V445.63h-5.42v-3.12h5.42v-4.66h2.41v-2.13h-2.86V418.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "499.46 418.27 499.46 459.66 518.91 459.66 518.91 445.37 513.49 445.37 513.49 442.51 518.91 442.61 518.91 437.94 521.37 437.94 521.33 435.53 518.46 435.46 518.46 418.2 499.46 418.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.85,443.88c0,.14-13.25.26-29.6.26s-29.59-.12-29.59-.26,13.24-.26,29.59-.26S500.85,443.73,500.85,443.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.85,441.49c0,.15-13.25.26-29.6.26s-29.59-.11-29.59-.26,13.24-.26,29.59-.26S500.85,441.35,500.85,441.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.65,435.08c0,.14-13.25.26-29.59.26s-29.6-.12-29.6-.26,13.25-.26,29.6-.26S504.65,434.93,504.65,435.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505,452.56c0,.14-13.25.26-29.6.26s-29.6-.12-29.6-.26,13.25-.26,29.6-.26S505,452.42,505,452.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.56,451c-1.54-1.32-5-5.5-2.33-10.37,1-1.79,3-2.67,4.9-3.45a19.93,19.93,0,0,0,5.38-2.79c2.91-2.48,3.72-6.59,5.65-9.9,2.22-3.8,6.36-6.64,10.74-6.44,5,.23,9.2,4.32,11.09,9s2,9.85,2,14.89c0,2.79-.1,5.94-2.15,7.82-1.88,1.73-4.72,1.76-7.28,1.68l-27.4-.84",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,375.65h-72l13,77.39a8.64,8.64,0,0,0,6.15,6.89l.25.07c.22.06.42.13.64.17a10.17,10.17,0,0,0,1.47.17v.07l.35-.06h32.12a9.29,9.29,0,0,0,1.76-.17,8.67,8.67,0,0,0,7.29-7.57l6.26-53.32.28-2.12h0l2.48-21.12ZM284.37,425H277l.74-22.46h8.57ZM287,402.55h7.08L291.45,425h-6.36Zm-21.13,47.37-.45-19.52h10.65l-.65,19.52ZM254.37,430.4h10.35l.45,19.52h-9.28Zm.8,19.52h-8.68c-.82-5.27-1.89-12.12-3.05-19.52h10.21ZM254,425l-1.74-22.46h11.87l.51,22.46Zm11.36,0-.52-22.46H277L276.26,425Zm-.64-27.84-.48-20.81h13.69l-.69,20.81Zm-.72,0H251.79l-1.62-20.81h13.3Zm-12.88,0H238.2l-1.28-8c-1.34-8.41-1.85-11.58-2.13-12.77h14.66Zm.42,5.38L253.23,425H242.59c-.36-2.27-.72-4.58-1.08-6.89-.84-5.3-1.67-10.6-2.46-15.57ZM241.87,425h-7l-3.76-22.46h7.18C239.43,409.49,240.64,417.22,241.87,425Zm.84,5.39c1.06,6.75,2.11,13.41,3.06,19.52h-6.68l-3.27-19.52Zm33.44,19.52.65-19.52h7.11l-1.67,19.52Zm1.75-52.75.69-20.81h9.94l-1.78,20.81Zm-43.79-20.81c.29,1.51,1.6,9.69,3.36,20.81h-7.23l-3.49-20.81Zm54.42,73.56H283l1.67-19.52h6.19Zm6.19-52.75h-7.25l1.78-20.81h7.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.97,
    y: 105.44,
    width: 35.62,
    height: 70.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.95,
    y: 105.44,
    width: 38.48,
    height: 70.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.95,
    y: 180.97,
    width: 38.48,
    height: 68.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.37 104.22 162.9 104.22 162.9 41.59 164.27 41.59 164.27 104.22 197.25 104.22 197.25 40.2 122.37 40.2 122.37 104.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.27,
    y: 105.44,
    width: 32.98,
    height: 70.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.27,
    y: 180.97,
    width: 32.98,
    height: 68.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.97,
    y: 180.97,
    width: 35.62,
    height: 68.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.37,
    y: 180.97,
    width: 40.53,
    height: 68.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.97,
    y: 250.41,
    width: 35.62,
    height: 61.47,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.27,
    y: 250.41,
    width: 32.98,
    height: 61.47,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.58 104.22 77.58 41.59 78.95 41.59 78.95 104.22 117.44 104.22 117.44 40.2 41.97 40.2 41.97 104.22 77.58 104.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.37,
    y: 250.41,
    width: 40.53,
    height: 61.47,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.95,
    y: 250.41,
    width: 38.48,
    height: 61.47,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.37,
    y: 105.44,
    width: 40.53,
    height: 70.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.42,388.67a20.33,20.33,0,0,1,12.65-1.54c2.29.38,4.68,1.07,6.25,2.79s1.85,4.75.06,6.23a5.91,5.91,0,0,1-3.94,1c-3.34,0-7-.62-9.72,1.39-1.52,1.14-2.54,3-4.36,3.62a4.32,4.32,0,0,1-4.74-2.11,7.38,7.38,0,0,1-.53-5.43A8.29,8.29,0,0,1,99.42,388.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.61,371.66c2.36,3.36,6.93,2.24,9,.19s3-5,3.83-7.85c1.86-6.48,3.74-13.27,2.35-19.86a11,11,0,0,0-2.53-5.4,5.8,5.8,0,0,0-5.47-1.82c-2.3.61-3.73,2.87-4.77,5a47.44,47.44,0,0,0-4.68,20.31c0,3.27.38,6.71,2.22,9.41",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.16,376.48c2.55-3,3-7.45,1.9-11.25a21.71,21.71,0,0,0-6.66-9.66,35.92,35.92,0,0,0-11.93-7,12.6,12.6,0,0,0-5.37-.91,5.61,5.61,0,0,0-4.5,2.72c-1.25,2.4-.05,5.3,1.25,7.67a90.51,90.51,0,0,0,7.84,11.93c2.34,3,5,6,8.61,7.38s7.3,1.21,9.2-1.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.45,422.32a6.57,6.57,0,0,0,.22-1.52c.11-1.11.24-2.51.4-4.17a61.13,61.13,0,0,1,.94-6.11,46.27,46.27,0,0,1,2.22-7.21,26.64,26.64,0,0,1,3.68-6.52,13.62,13.62,0,0,1,4.66-3.87,13,13,0,0,1,3.92-1.22,7.69,7.69,0,0,0,1.52-.22,6.9,6.9,0,0,0-1.55,0,11.93,11.93,0,0,0-4.09,1.07,13.82,13.82,0,0,0-4.91,3.9,25.83,25.83,0,0,0-3.81,6.66,42.84,42.84,0,0,0-2.21,7.33,52.2,52.2,0,0,0-.81,6.18c-.13,1.77-.18,3.2-.21,4.19A7.69,7.69,0,0,0,90.45,422.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.74,419.12a2.83,2.83,0,0,0,0-.71v-2c0-1.76,0-4.31.09-7.45.15-6.28.69-13,1.74-22.57,1-9,2.32-19.39,3.72-26.17.3-1.54.6-2.93.88-4.15s.51-2.26.73-3.11.35-1.45.47-2a2.75,2.75,0,0,0,.13-.7,2.68,2.68,0,0,0-.25.66c-.15.51-.35,1.16-.59,1.94s-.52,1.89-.83,3.1-.65,2.6-1,4.14A230.07,230.07,0,0,0,92,384.39c-1,9.55-1.52,18.25-1.56,24.55,0,3.14,0,5.69.11,7.45,0,.82.09,1.49.13,2A3,3,0,0,0,90.74,419.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.78,402.35a12.33,12.33,0,0,0,0-2.12c-.08-1.36-.27-3.32-.65-5.73a76.81,76.81,0,0,0-1.86-8.35,69,69,0,0,0-3.5-9.88,52.61,52.61,0,0,0-10.25-16,26.38,26.38,0,0,0-2.41-2.24c-.37-.32-.7-.63-1-.87l-.94-.65a13.65,13.65,0,0,0-1.78-1.14,63.65,63.65,0,0,1,5.84,5.21,55.7,55.7,0,0,1,10,15.91,77.61,77.61,0,0,1,3.51,9.79c.91,3.07,1.52,5.89,2,8.27s.69,4.32.84,5.67A15,15,0,0,0,90.78,402.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.57 431.93 76.25 454.96 105.83 454.96 107.51 431.93 74.57 431.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.72,
    y: 422.86,
    width: 39.33,
    height: 9.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.72 454.08 71.72 456.59 73.56 456.59 110.39 456.59 110.39 454.08 71.72 454.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.37 461.02 73.56 456.59 108.98 456.59 106.87 461.02 75.37 461.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,439.46a.93.93,0,0,1-.13.21l-.45.59-1.72,2.2-.08.1-.07-.1-4.23-5.86h.24l-4.17,5.9-.13.19-.14-.18-5-5.88h.29l-.27.34c-1.54,1.92-3,3.78-4.42,5.54l-.15.19-.14-.2-4.17-5.9.24,0-5.13,5.85-.09.1-.07-.12c-.68-1.13-1.22-2-1.61-2.7L75.2,439a1.34,1.34,0,0,1-.13-.25s.07.07.17.23l.46.69,1.69,2.65h-.16c1.31-1.55,3-3.56,5-5.93l.13-.15.11.17,4.21,5.87h-.28l4.41-5.55.27-.34.14-.18.14.18,4.93,5.89h-.27c1.52-2.12,2.93-4.1,4.21-5.87l.12-.17.12.17,4.14,5.92h-.15l1.8-2.15.48-.55C106.9,439.51,107,439.45,107,439.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.92,431.78c0,.1-7.41.19-16.55.19s-16.55-.09-16.55-.19,7.41-.18,16.55-.18S107.92,431.68,107.92,431.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.42,456.84c0,.1-8.06.19-18,.19s-18-.09-18-.19,8-.18,18-.18S109.42,456.74,109.42,456.84Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600,375.25c-.09.11-.83-.34-1.65-1s-1.42-1.29-1.33-1.4.83.33,1.65,1S600.12,375.14,600,375.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.53,341.63c.13-3.14.22-6.36-.77-9.35s-3.29-5.72-6.37-6.36c-3.52-.73-7.12,1.49-9.08,4.49s-2.65,6.64-3.23,10.18a359.44,359.44,0,0,0-4.41,73.92l14.38,2C619.36,390.72,621.38,368.17,622.53,341.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.39,325.81a.7.7,0,0,1-.06.23c-.07.17-.14.39-.24.65-.23.61-.55,1.44-1,2.48-.2.54-.47,1.13-.68,1.8s-.45,1.4-.7,2.18-.52,1.61-.8,2.5-.49,1.85-.75,2.85a125.5,125.5,0,0,0-2.77,14.23c-.78,5.41-1.29,11.4-1.69,17.69-.74,12.6-.85,24-1.18,32.3-.15,4.14-.29,7.48-.45,9.79-.08,1.12-.14,2-.18,2.66,0,.28,0,.5-.06.69a.92.92,0,0,1,0,.24,1,1,0,0,1,0-.24v-.7c0-.65,0-1.54.08-2.66.1-2.31.18-5.66.29-9.79.23-8.27.29-19.7,1-32.32.41-6.31.93-12.31,1.74-17.73a119.38,119.38,0,0,1,2.89-14.25c.28-1,.54-2,.78-2.86s.58-1.71.85-2.49.51-1.5.74-2.17.51-1.25.73-1.79c.44-1,.79-1.85,1-2.45l.29-.63C613.35,325.87,613.38,325.8,613.39,325.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.72,325.82a10,10,0,0,1,1.76,3,22,22,0,0,1,1.31,9.3c-.38,8-1.09,18.9-2,31s-2,23-2.85,30.92c-.42,3.95-.79,7.15-1.06,9.35-.14,1.07-.25,1.91-.33,2.54,0,.26-.07.48-.1.66a.63.63,0,0,1,0,.22.68.68,0,0,1,0-.23c0-.18,0-.4,0-.66.06-.63.13-1.48.23-2.55.22-2.26.52-5.45.9-9.36.75-7.91,1.75-18.84,2.7-30.93s1.72-23,2.19-30.95a22.7,22.7,0,0,0-1.13-9.22A18.34,18.34,0,0,0,614.72,325.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.69,363a15.8,15.8,0,0,1-5.27-1.89,15.24,15.24,0,0,1,5.27,1.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.43,348.38a9.34,9.34,0,0,1-2.6,1.44,8.84,8.84,0,0,1-2.8,1,17,17,0,0,1,5.4-2.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.53,336.41a4.4,4.4,0,0,1-2.15.11,4.63,4.63,0,0,1-2.1-.4,9,9,0,0,1,4.25.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.69,328.75c-.12.08-.75-.71-1.41-1.75s-1.09-1.95-1-2,.75.71,1.41,1.76A5.18,5.18,0,0,1,610.69,328.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.79,336a4.35,4.35,0,0,1-2,.22,4.4,4.4,0,0,1-2-.3c0-.15.92-.24,2-.22A4.4,4.4,0,0,1,605.79,336Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.27,350.45c-.06.14-1-.13-2.15-.59s-2-.93-2-1.06a5,5,0,0,1,2.15.59C601.44,349.85,602.32,350.32,602.27,350.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.89,362.62c0,.14-.79.43-1.83.65s-1.91.28-1.93.14.79-.43,1.83-.64S601.86,362.48,601.89,362.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.23,382.53c0,.14-.84.41-1.94.61s-2,.24-2,.1.84-.41,1.94-.61S600.21,382.39,600.23,382.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.13,393.52c.07.12-.66.64-1.62,1.15s-1.79.81-1.86.69.66-.64,1.62-1.15S599.07,393.39,599.13,393.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.11,406c-.13.07-.76-.8-1.42-1.95a5.86,5.86,0,0,1-1-2.2c.12-.07.75.8,1.41,2A5.79,5.79,0,0,1,608.11,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.7,385.26c.09.11-.61,1-1.58,1.9s-1.83,1.64-1.93,1.54.61-.95,1.57-1.9S610.6,385.16,610.7,385.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.12,374.39c-.1.1-.75-.44-1.46-1.2s-1.18-1.45-1.08-1.54.76.44,1.46,1.19S610.23,374.29,610.12,374.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.9,360.49c.11.1-.48.93-1.31,1.85s-1.59,1.6-1.69,1.51.48-.93,1.31-1.85S611.8,360.4,611.9,360.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.9,350.41c-.1.1-.91-.54-1.82-1.44s-1.57-1.7-1.47-1.8.92.54,1.83,1.44S613,350.31,612.9,350.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.87,336.78a5.11,5.11,0,0,1-.92,2c-.62,1.05-1.23,1.85-1.35,1.78s.28-1,.91-2S614.75,336.71,614.87,336.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.58,324.15a4.94,4.94,0,0,1-.82,2c-.57,1.06-1.14,1.86-1.26,1.8a5,5,0,0,1,.81-2.05C617.89,324.88,618.45,324.08,618.58,324.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.78,329.88c.06.13-.52.53-1.29.9s-1.44.57-1.5.44.51-.53,1.28-.9S622.72,329.76,622.78,329.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.88,375.25a5.92,5.92,0,0,1-2.81-.68,5.79,5.79,0,0,1-2.44-1.56,14.66,14.66,0,0,1,2.64,1.09A14.39,14.39,0,0,1,622.88,375.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.16,384.86c0,.14-.84.42-1.93.63s-2,.27-2,.13.83-.42,1.93-.63A4.19,4.19,0,0,1,621.16,384.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.05,401.34a5.71,5.71,0,0,1-2.19-1.93,5.6,5.6,0,0,1-1.37-2.57,17.53,17.53,0,0,1,1.77,2.25A15.86,15.86,0,0,1,619.05,401.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.94,408.87c-.09-.11.49-.76,1.3-1.45s1.55-1.17,1.64-1.07-.49.76-1.3,1.46S596,409,595.94,408.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.29,372.91c-.93-2.92-2.69-6.33-5.76-6.37a5.1,5.1,0,0,0-4.31,2.88,10.68,10.68,0,0,0-1.17,5.29,137.76,137.76,0,0,0,6.6,38.3h11.22A133,133,0,0,0,589.29,372.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569,354.52c-1.57-6.28-6.25-9.67-11.69-10-5,.87-6.88,5.76-7.47,10.76s1,10,2.49,14.79q7.39,23.1,14.78,46.22l14-1.53C576.65,394.13,574.11,375,569,354.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.53,366.54a11.8,11.8,0,0,0-.95,1.59,10.48,10.48,0,0,0-.52,5c.21,2.13.46,4.7.82,7.52s.87,5.91,1.5,9.13c1.27,6.45,2.7,12.24,3.61,16.46.46,2.11.81,3.82,1,5,.1.54.18,1,.24,1.37a2.15,2.15,0,0,1,0,.48,1.7,1.7,0,0,1-.15-.46l-.33-1.35-1.19-5c-1-4.19-2.48-10-3.75-16.44-.64-3.23-1.13-6.33-1.47-9.17-.18-1.42-.3-2.77-.42-4s-.24-2.43-.3-3.52a10.24,10.24,0,0,1,.71-5.07A4.54,4.54,0,0,1,583.53,366.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.5,344.14a18.1,18.1,0,0,0-1.68,2.26,16,16,0,0,0-2.13,7.31A33.85,33.85,0,0,0,555.42,365c1.23,4.15,2.57,8.71,4,13.5L566.55,403c.88,3.12,1.6,5.65,2.11,7.47l.55,2a3.94,3.94,0,0,1,.16.72,3.12,3.12,0,0,1-.26-.69l-.64-2c-.55-1.8-1.32-4.32-2.27-7.41l-7.29-24.53c-1.4-4.8-2.73-9.36-3.95-13.52a33.49,33.49,0,0,1-1.63-11.4,15.59,15.59,0,0,1,2.32-7.39A8.64,8.64,0,0,1,557.5,344.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578,413.28a4.58,4.58,0,0,1-.31-.67c-.19-.45-.48-1.1-.8-2-.66-1.72-1.52-4.25-2.4-7.42s-1.76-7-2.6-11.27-1.7-9-2.63-13.89-2.06-9.57-3.31-13.72a77,77,0,0,0-4.07-10.76,57.3,57.3,0,0,0-3.77-6.79c-.48-.78-.91-1.34-1.17-1.75a5.22,5.22,0,0,1-.4-.63,3.25,3.25,0,0,1,.48.57c.29.39.75.93,1.26,1.7a50.78,50.78,0,0,1,3.92,6.74,72.6,72.6,0,0,1,4.2,10.78A136.09,136.09,0,0,1,569.78,378c.92,4.93,1.79,9.62,2.59,13.9s1.65,8.09,2.49,11.26,1.63,5.71,2.24,7.45c.29.87.55,1.53.7,2A3.64,3.64,0,0,1,578,413.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.57,367.77c0,.14-.72.44-1.69.67s-1.79.32-1.82.18.73-.44,1.7-.67S552.54,367.63,552.57,367.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.09,358.24a17.48,17.48,0,0,1-4.72.18,4.83,4.83,0,0,1,2.35-.44A4.68,4.68,0,0,1,551.09,358.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.67,349.53c-.09.11-.85-.38-1.7-1.1s-1.45-1.38-1.36-1.49.85.38,1.7,1.1S552.76,349.42,552.67,349.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.93,341.47c.14,0,.1.71.08,1.53s0,1.5-.17,1.53-.37-.66-.34-1.54S556.79,341.44,556.93,341.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.64,345.27c.11.08-.23.77-.77,1.54s-1.06,1.32-1.18,1.24.22-.77.76-1.54S565.52,345.19,565.64,345.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.28,355.08c.06.14-.66.55-1.61.94s-1.76.59-1.81.46.67-.55,1.62-.94S571.23,355,571.28,355.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.71,365.18a6.39,6.39,0,0,1-4.63,1.05,49.5,49.5,0,0,1,4.63-1.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559,362.31c-.14,0,0-.74.21-1.55s.58-1.45.71-1.41,0,.74-.22,1.56S559.11,362.36,559,362.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.17,375a4.85,4.85,0,0,1,.63-2.1c.48-1.1,1-1.95,1.11-1.89a4.88,4.88,0,0,1-.64,2.1C561.79,374.2,561.3,375.05,561.17,375Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.75,378.46c-.06.14-.94-.1-2-.44s-1.94-.64-1.91-.78,1-.05,2.06.29S555.8,378.34,555.75,378.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.87,388.8c.09.12-.51.69-1.33,1.27s-1.55,1-1.64.85.52-.68,1.34-1.27S558.79,388.69,558.87,388.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.38,399.11c0,.14-.71.43-1.65.66s-1.74.31-1.78.17.71-.43,1.66-.66S561.35,399,561.38,399.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575,373.79c.07.12-.56.63-1.48,1s-1.73.39-1.76.25.7-.4,1.57-.73S574.92,373.67,575,373.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.93,389.83c-.06.13-.81-.1-1.68-.51s-1.53-.85-1.47-1,.82.09,1.69.5S577,389.7,576.93,389.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.37,401.3a5.32,5.32,0,0,1-2.23-.59c-1.18-.46-2.09-.95-2-1.08a5.43,5.43,0,0,1,2.22.6A5.37,5.37,0,0,1,580.37,401.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.93,410.29c-.07-.13.85-.74,1.91-1.58a10.24,10.24,0,0,1,2-1.48c.11.09-.56,1-1.67,1.88A4.63,4.63,0,0,1,561.93,410.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571,404.46c-.14,0-.34-.76-.69-1.65s-.71-1.61-.6-1.69.71.53,1.08,1.5S571.14,404.45,571,404.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.6,390.66c-.08.11-.67-.17-1.31-.63s-1.09-.92-1-1,.67.17,1.31.63S568.68,390.54,568.6,390.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.75,369c.08.11-.49.68-1.28,1.26s-1.49,1-1.58.85.49-.68,1.28-1.26S589.66,368.92,589.75,369Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.93,377.74c0,.14-.88.33-2,.21s-1.94-.49-1.9-.62.9,0,2,.11S592.92,377.6,592.93,377.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.23,379.7c0,.13-.79.43-1.86.5s-1.93-.11-1.92-.25.86-.19,1.88-.26S579.2,379.56,579.23,379.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.41,371.46c0,.14-.85.16-1.76-.26s-1.45-1.07-1.35-1.17.73.32,1.56.7S580.43,371.31,580.41,371.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.11,387.1c-.08.12-.93-.28-1.91-.9s-1.72-1.22-1.64-1.34.93.29,1.91.9S594.19,387,594.11,387.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554.45,
    y: 411.55,
    width: 73.09,
    height: 12.96,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "559.9 421.94 568.79 460.65 612.36 460.65 622.08 421.94 559.9 421.94",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.5,424.52c0,.14-16.49.26-36.82.26s-36.83-.12-36.83-.26,16.49-.26,36.83-.26S627.5,424.38,627.5,424.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.85,380c-.12.08-.62-.51-1.12-1.3s-.8-1.5-.68-1.57.62.5,1.12,1.3S587,379.91,586.85,380Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.88,390.4c-.14,0,0-.92.38-2s.73-1.85.87-1.81a4.2,4.2,0,0,1-.38,2C587.4,389.64,587,390.45,586.88,390.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.44,401.35a5.59,5.59,0,0,1-1.22-2,5.31,5.31,0,0,1-.75-2.17c.13-.06.67.81,1.22,1.95A5.33,5.33,0,0,1,590.44,401.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.72,410.15c-.1-.09.33-.77,1-1.51s1.25-1.27,1.36-1.18-.33.77-1,1.51S582.83,410.24,582.72,410.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.1,394.17c0,.14-.72.13-1.57,0s-1.5-.38-1.48-.52.73-.13,1.57,0S581.13,394,581.1,394.17Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tasks--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.88,311h11.47S511.19,133.87,512.6,83.89L510.82,311Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.06,30.6S513.93,28,512.78,75.42C509.46,212.72,525.61,316,525.61,316H365V35.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,389.81l111.43-.07a24.27,24.27,0,0,0,24.26-24.27l-.06-279.36A24.26,24.26,0,0,0,472.3,61.84l-111.43.07a24.25,24.25,0,0,0-24.26,24.27l.05,279.36A24.27,24.27,0,0,0,361,389.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,71.79l21.61,0,63.09,0h26.51a17,17,0,0,1,17,17l.05,272.67a17,17,0,0,1-17,17l-111.21.07a17,17,0,0,1-17-17L344,88.79A17,17,0,0,1,361,71.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,30.57l106.64,1C466,30.84,462.66,37.06,460.09,41c-4.89,7.55-4.4,16.17,1.19,23.23a22.2,22.2,0,0,0,12.66,7.44l-116.85,0c-6.8-6.67-8.22-13.78-7.21-20.18C351.8,39.36,362.63,30.57,375,30.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.49,36.17a3.65,3.65,0,0,1-.68-.41,18,18,0,0,0-1.93-1.14A26.41,26.41,0,0,0,483,32.16a27.68,27.68,0,0,0-12.11.65,19.42,19.42,0,0,0-11.17,9.31,20.82,20.82,0,0,0-2.33,14.41,16.6,16.6,0,0,0,2.68,5.88A20.64,20.64,0,0,0,464,66.55a26.41,26.41,0,0,0,7.11,4.16c1.82.7,2.89.93,2.87,1a4.42,4.42,0,0,1-.77-.16A20.18,20.18,0,0,1,471,70.9a25.09,25.09,0,0,1-7.27-4.06,21.05,21.05,0,0,1-4-4.18,16.78,16.78,0,0,1-2.79-6,21.08,21.08,0,0,1,2.34-14.77,19.8,19.8,0,0,1,11.48-9.52,27.71,27.71,0,0,1,12.31-.55A25,25,0,0,1,491,34.44a15.25,15.25,0,0,1,1.91,1.24A5.3,5.3,0,0,1,493.49,36.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498,38.68a13.76,13.76,0,0,1,2.36,1.64,33.58,33.58,0,0,1,5.59,6,35.07,35.07,0,0,1,3.15,5.06,26.84,26.84,0,0,1,2.41,6.67c.57,2.52.34,5.27.44,8.13s.17,5.92.26,9.11c.22,6.39.51,13.38.85,20.89,0,3.77,0,7.64-.06,11.65s0,8.12,0,12.35c0,16.89.36,35.47,1.09,55,1.41,39,4.29,74.19,6.82,99.62,1.3,12.72,2.45,23,3.28,30.09.42,3.54.75,6.29,1,8.17q.15,1.4.24,2.13c0,.48.06.73.06.73s0-.24-.12-.72-.16-1.2-.29-2.12c-.24-1.89-.6-4.63-1.06-8.16-.9-7.1-2.1-17.37-3.45-30.08-2.62-25.43-5.56-60.64-7-99.64-.73-19.49-1-38.07-1-55,0-4.23,0-8.35,0-12.35s.1-7.89.09-11.63c-.33-7.51-.59-14.51-.79-20.9-.09-3.19-.17-6.23-.22-9.11s.15-5.61-.4-8.08a26.45,26.45,0,0,0-2.34-6.62,35.47,35.47,0,0,0-3.09-5.05,35.06,35.06,0,0,0-5.5-6.07,10.69,10.69,0,0,0-1-.78,8.53,8.53,0,0,0-.72-.53C498.19,38.83,498,38.68,498,38.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.2,241.87S487.8,352,479,368.07l-155.16-2L327,352.84,489.25,153.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.2,88.72s-2.78,244.08-18.44,265.43H319.56S354.35,171,344,88.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.51,88.72s-2.78,244.08-18.44,265.43H319.56s24.25-180.38,24.25-261.44",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.81,92.71V94c0,.86,0,2.14,0,3.81s0,3.76-.09,6.22-.05,5.31-.21,8.52c-.43,12.85-1.45,31.53-3.26,54.88-3.73,46.69-10.61,112-20.4,186.76l-.25-.29H472.07l-.2.1a24.48,24.48,0,0,0,2.76-6.45c.64-2.27,1.21-4.55,1.67-6.85,1-4.59,1.69-9.19,2.34-13.75,1.28-9.13,2.21-18.14,3-27,1.59-17.67,2.67-34.62,3.57-50.68,1.75-32.13,2.75-60.69,3.48-84.49s1.13-42.81,1.4-55.89c.12-6.53.22-11.58.29-15,0-1.71.06-3,.07-3.88s0-1.32,0-1.32,0,.44,0,1.32,0,2.17,0,3.88c-.05,3.42-.12,8.47-.2,15-.22,13.08-.58,32.11-1.25,55.9s-1.64,52.37-3.37,84.5c-.88,16.07-1.95,33-3.53,50.7-.81,8.84-1.73,17.85-3,27-.65,4.57-1.37,9.18-2.33,13.78-.47,2.31-1,4.61-1.69,6.89a24.53,24.53,0,0,1-2.83,6.61l-.07.11H319.27l0-.29c9.81-74.72,16.76-140,20.57-186.72,1.86-23.34,2.93-42,3.42-54.85.17-3.21.2-6.06.25-8.52s.09-4.54.13-6.22.06-3,.08-3.81S343.81,92.71,343.81,92.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.23,88.41s-.34-17-17-17-115.1,0-115.1,0S344,75.05,344,89.62l102.83,7.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,30.57h-.28c-.18,0-.46,0-.82,0a21.28,21.28,0,0,0-3.16.27,24,24,0,0,0-10.82,4.6,28.24,28.24,0,0,0-9.78,14.9,19.94,19.94,0,0,0,.45,10.82,21.65,21.65,0,0,0,2.5,5.32,23.56,23.56,0,0,0,3.87,4.74l-.16-.06,29.39,0,61.62.2,18.68.12,5.07.06,1.32,0,.45,0s-.15,0-.45,0l-1.32,0-5.07,0-18.68,0-61.62,0-29.39-.07h-.1l-.06-.06a24.82,24.82,0,0,1-4-4.85,23.1,23.1,0,0,1-2.53-5.44,20.41,20.41,0,0,1-.41-11.06,28.29,28.29,0,0,1,10-15,22.55,22.55,0,0,1,6-3.28,22.2,22.2,0,0,1,5-1.24,18.33,18.33,0,0,1,3.18-.19A7.13,7.13,0,0,1,375,30.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.25,187s0,.3,0,.87,0,1.44,0,2.56v9.81c0,8.52-.08,20.86-.24,36.1s-.41,33.39-1.08,53.53c-.34,10.07-.82,20.65-1.84,31.57s-2.43,22.2-4.39,33.67c-.77,4.49-1.59,8.91-2.49,13.05l-.05.2H479c-43.48-.1-82.27-.81-110.19-1.29l-32.95-.66-8.92-.21-2.31-.07-.79,0h.79l2.32,0,8.91.12,33,.5c27.92.38,66.71,1,110.18,1.12l-.25.2c.9-4.11,1.72-8.54,2.49-13,1.95-11.45,3.36-22.72,4.39-33.63s1.52-21.47,1.87-31.54c.7-20.13.95-38.28,1.19-53.52s.31-27.55.41-36.09c0-4.25.07-7.56.09-9.81,0-1.12,0-2,0-2.56S489.25,187,489.25,187Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.12,99.44a98,98,0,0,1-14.27,0,98,98,0,0,1,14.27,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.12,95.71a98,98,0,0,1-14.27,0,98,98,0,0,1,14.27,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.12,92a98,98,0,0,1-14.27,0,98,98,0,0,1,14.27,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.47,101.85l.31,0,.85,0,3.15-.08-.09.09q0-1.05,0-2.28c0-.43,0-.83,0-1.32a1.21,1.21,0,0,1,1.06-1c.51,0,.95,0,1.5,0a1.24,1.24,0,0,1,1,1.22c0,1.07,0,2.18,0,3.33l-.15-.14,4,0-.15.15c0-1.6,0-3.25,0-5,0-.42,0-.84,0-1.26a1.28,1.28,0,0,0-.56-.94l-1.74-1.71L368,91.23l-.82-.8c-.28-.27-.5-.55-.82-.61a1.05,1.05,0,0,0-.91.17c-.24.2-.5.49-.74.73l-1.43,1.44c-.89.93-1.83,1.78-2.51,2.58a2.8,2.8,0,0,0-.2,1.49v1.4c0,.86,0,1.61,0,2.25s0,1.06,0,1.45,0,.51,0,.52a2.76,2.76,0,0,1,0-.48c0-.38,0-.85,0-1.42s0-1.41,0-2.28l0-1.42c0-.26,0-.52,0-.79a1.66,1.66,0,0,1,.22-.83c.74-.9,1.61-1.7,2.52-2.65l1.41-1.45c.26-.26.47-.5.77-.77a1.35,1.35,0,0,1,1.15-.22,2.13,2.13,0,0,1,1,.68l.81.8,1.69,1.65,1.74,1.71a3.48,3.48,0,0,1,.44.48,1.32,1.32,0,0,1,.21.67c0,.42,0,.84,0,1.27,0,1.69,0,3.35,0,5v.15h-.15l-4,0H368v-.14c0-1.16,0-2.27,0-3.34a1,1,0,0,0-.81-1c-.45,0-1,0-1.44,0a1,1,0,0,0-.85.78c0,.4,0,.86,0,1.27v2.37h-.09l-3.2,0-.84,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.85,95.31h-1.94V93.89h5.67v1.42h-1.94v4.9h-1.79Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.17,99h-2.68l-.49,1.22h-1.83L410,93.89h1.76l2.8,6.32h-1.86Zm-.53-1.32-.81-2-.81,2Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.59,99.65l.59-1.32a4,4,0,0,0,2.08.62c.74,0,1-.21,1-.52,0-1-3.59-.27-3.59-2.61,0-1.13.92-2,2.8-2a4.62,4.62,0,0,1,2.29.55l-.55,1.32a3.76,3.76,0,0,0-1.75-.48c-.75,0-1,.25-1,.56,0,1,3.58.25,3.58,2.58,0,1.1-.92,2-2.8,2A5,5,0,0,1,414.59,99.65Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.32,97.92l-.67.71v1.58h-1.77V93.89h1.77v2.63l2.45-2.63h2l-2.59,2.8,2.72,3.52h-2.08Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.09,99.65l.59-1.32a4,4,0,0,0,2.09.62c.74,0,1-.21,1-.52,0-1-3.6-.27-3.6-2.61,0-1.13.92-2,2.8-2a4.66,4.66,0,0,1,2.3.55l-.55,1.32a3.8,3.8,0,0,0-1.76-.48c-.75,0-1,.25-1,.56,0,1,3.59.25,3.59,2.58,0,1.1-.92,2-2.8,2A5.06,5.06,0,0,1,427.09,99.65Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.18,115.91c0,.14-32.28.26-72.08.26s-72.09-.12-72.09-.26,32.27-.26,72.09-.26S487.18,115.77,487.18,115.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.42,165.71c0,.14-32.27.26-72.08.26s-72.08-.12-72.08-.26,32.26-.26,72.08-.26S488.42,165.56,488.42,165.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.82,213.48c0,.14-33.63.26-75.1.26s-75.11-.12-75.11-.26,33.62-.26,75.11-.26S486.82,213.33,486.82,213.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.8,260.05c0,.15-34.5.26-77,.26s-77-.11-77-.26,34.48-.26,77-.26S484.8,259.91,484.8,260.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480,312.44c0,.15-34.63.26-77.33.26s-77.33-.11-77.33-.26,34.62-.26,77.33-.26S480,312.3,480,312.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.55,150.36a1.5,1.5,0,0,1,0-.33c0-.25,0-.55,0-.91,0-.85,0-2-.06-3.41,0-3-.06-7.09-.11-12l.23.22-16.67,0,.26-.26h0v4.47c0,1.46,0,2.9,0,4.3,0,2.8,0,5.44,0,7.86l-.23-.22,12,.11,3.41.06.91,0,.34,0a8.35,8.35,0,0,1-1.16.06l-3.36.05-12.15.12h-.22v-.23c0-2.42,0-5.06,0-7.86,0-1.4,0-2.84,0-4.3v-4.47h0l.26-.26,16.67,0h.22v.23c0,5-.09,9.16-.11,12.15,0,1.4-.05,2.53-.06,3.36S372.56,150.38,372.55,150.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.44,140.9c0,.14-19,.26-42.49.26s-42.49-.12-42.49-.26,19-.26,42.49-.26S468.44,140.75,468.44,140.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.3,147.5c0,.15-9.81.27-21.92.27s-21.92-.12-21.92-.27,9.81-.26,21.92-.26S427.3,147.36,427.3,147.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,124.89c.69.18-.62,7.45-3.55,16-.37,1.07-.74,2.11-1.11,3.11l-.56,1.47-.28.71-.08.18a2.41,2.41,0,0,1-.15.33,3,3,0,0,1-.44.57,2.47,2.47,0,0,1-2.53.53,2.42,2.42,0,0,1-1-.75l-.17-.25-.09-.16-.17-.3c-.42-.78-.78-1.53-1.09-2.21-1.23-2.74-1.71-4.54-1.4-4.69s1.4,1.35,3,3.8l1.32,2,.19.26.08.12,0,0,.08,0c.05,0,.12,0,.11-.07v0h0l.06-.17.24-.72c.16-.49.32-1,.49-1.48l1-3.1C369.86,131.6,372.28,124.71,373,124.89Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.72,200.57a2.4,2.4,0,0,1,0-.33c0-.25,0-.55,0-.91q0-1.28-.06-3.42c0-3-.07-7.08-.11-12l.22.22-16.66,0,.26-.26h0v4.48c0,1.47,0,2.91,0,4.31,0,2.79,0,5.43,0,7.86l-.22-.22,12,.11,3.41.06.91,0a1.32,1.32,0,0,1,.33,0,9.48,9.48,0,0,1-1.15.05l-3.36.06-12.15.12h-.23v-.23c0-2.43,0-5.07,0-7.86,0-1.4,0-2.84,0-4.31v-4.48h0c-.24.23.31-.32.26-.26l16.66,0H371v.23c-.05,5-.09,9.15-.12,12.15q0,2.1-.06,3.36A7.35,7.35,0,0,1,370.72,200.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.62,191.1c0,.15-19,.27-42.49.27s-42.5-.12-42.5-.27,19-.26,42.5-.26S466.62,191,466.62,191.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,247.29s0-.12,0-.33,0-.55,0-.91c0-.85,0-2-.06-3.41,0-3-.06-7.09-.11-12l.22.22-16.66,0,.26-.26h0v4.46c0,1.47,0,2.91,0,4.31,0,2.8,0,5.44,0,7.86l-.22-.22,12,.11,3.41.06.91,0,.33,0a7.92,7.92,0,0,1-1.15.06l-3.36.05-12.15.12h-.22v-.23c0-2.42,0-5.06,0-7.86,0-1.4,0-2.84,0-4.31v-4.46h0l.26-.26,16.66,0h.23v.23c-.05,5-.09,9.15-.12,12.15,0,1.4,0,2.53-.05,3.36A7.92,7.92,0,0,1,368.14,247.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,237.83c0,.14-19,.26-42.49.26s-42.49-.12-42.49-.26,19-.26,42.49-.26S464,237.68,464,237.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.11,296.74a1.5,1.5,0,0,1,0-.33c0-.25,0-.55,0-.91,0-.85,0-2-.06-3.41,0-3-.07-7.09-.12-12l.23.22-16.66,0c-.06.06.49-.49.25-.26h0v8.77c0,2.8,0,5.44,0,7.86l-.23-.22,12,.11,3.41.06.92,0,.33,0a7.92,7.92,0,0,1-1.15.06l-3.36.05-12.16.12h-.22v-.23c0-2.42,0-5.06,0-7.86v-4.3c0-.74,0-1.48,0-2.23v-2.24h0c-.23.23.32-.32.27-.26l16.66,0h.23v.23c0,5-.08,9.16-.11,12.15,0,1.4,0,2.53-.06,3.36A9.48,9.48,0,0,1,364.11,296.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460,287.28c0,.14-19,.26-42.49.26s-42.5-.12-42.5-.26,19-.26,42.5-.26S460,287.13,460,287.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.71,343.65s0-.12,0-.33,0-.55,0-.92c0-.84,0-2-.06-3.41,0-3-.06-7.08-.11-12l.22.23-16.66,0,.26-.26h0v4.48c0,1.47,0,2.91,0,4.31,0,2.79,0,5.43,0,7.86l-.23-.23,12,.12,3.41.06.91,0,.33,0s-.38,0-1.15.05l-3.36.06-12.15.11h-.22v-.22c0-2.43,0-5.07,0-7.86,0-1.4,0-2.84,0-4.31V327h0l.26-.26,16.66,0h.23V327c-.05,5-.09,9.16-.11,12.15q0,2.12-.06,3.36A8.35,8.35,0,0,1,361.71,343.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.57,333.35c0,.14-19,.26-42.49.26s-42.5-.12-42.5-.26,19-.26,42.5-.26S460.57,333.21,460.57,333.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.14,244.24c0,.15-14.95.26-33.4.26s-33.4-.11-33.4-.26,15-.26,33.4-.26S445.14,244.1,445.14,244.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.62,295.34c0,.15-6.05.26-13.52.26s-13.52-.11-13.52-.26,6.05-.26,13.52-.26S402.62,295.2,402.62,295.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.27,30.76c0,.14-21.28.26-47.52.26s-47.53-.12-47.53-.26,21.28-.26,47.53-.26S470.27,30.62,470.27,30.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683.17,460.65c0,.14-138,.26-308.16.26s-308.18-.12-308.18-.26,138-.26,308.18-.26S683.17,460.51,683.17,460.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.58,194.46s25.61,36,30.41,37.56c16.43,5.46,34.6-32.35,34.6-32.35l-9.77,2.15-17.93,11.31-19.57-26.76-17.74,10.21",
    style: {
      fill: "#a57e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.12,224.06a4.13,4.13,0,0,1-.24-1.75,12,12,0,0,1,2.9-7.87,4.44,4.44,0,0,1,1.32-1.17,21,21,0,0,0-3,5A20.81,20.81,0,0,0,265.12,224.06Z",
    style: {
      fill: "#755246"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.7 435.25 272.36 452.46 284.41 453.54 289.49 447.83 284.84 427.28 268.7 435.25",
    style: {
      fill: "#a57e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.34,432.2c-.17.56,0,22,0,22l6.76,4,8.83-5.3,1.87-20.73Z",
    style: {
      fill: "#a57e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.6,246.76s-8.67,16.4-12.39,29.81-7.27,21.07-3.44,33.11,8.94,57.67,11.46,69.71c2.07,9.92,6.66,48.76,10,61.07H214l1.91-137.9S249.28,380,253.11,389.3s15.05,49,15.05,49l19.43-3s-11.77-68.67-15.33-85.09-13.68-61-17.78-75-3.68-23.63-9.5-30.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.44,249.46s.1-.15.37-.26a1.9,1.9,0,0,1,1.25,0,1.85,1.85,0,0,1,1.23,1.41,2,2,0,0,1-3.18,2,1.85,1.85,0,0,1-.73-1.72,1.81,1.81,0,0,1,.54-1.12c.21-.21.37-.25.39-.23a2.68,2.68,0,0,0-.56,1.37,1.49,1.49,0,0,0,.64,1.31,1.53,1.53,0,0,0,2.42-1.51,1.48,1.48,0,0,0-.89-1.15A2.52,2.52,0,0,0,218.44,249.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.88,285.09a2.18,2.18,0,0,1-.45.13c-.31.07-.76.15-1.34.22a18.45,18.45,0,0,1-5-.08,13.86,13.86,0,0,1-1.65-.34,2.1,2.1,0,0,1-.83-.49,1.71,1.71,0,0,1-.45-.91c-.16-1.29-.15-2.57-.23-4-.12-2.78-.24-5.83-.38-9-.25-6.41-.45-12.21-.57-16.41,0-2-.09-3.72-.12-5v-1.35a1.43,1.43,0,0,1,0-.47,1.62,1.62,0,0,1,.07.47c0,.37.07.81.11,1.35.07,1.25.16,2.93.28,5,.21,4.2.47,10,.72,16.4.12,3.2.24,6.25.34,9,.07,1.37.05,2.75.17,3.91a1.35,1.35,0,0,0,1,1.1,12.84,12.84,0,0,0,1.58.36,20.6,20.6,0,0,0,4.92.24C223.23,285.16,223.87,285,223.88,285.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.38,262.4a3,3,0,0,1-.77.57,10,10,0,0,1-2.42,1A10.56,10.56,0,0,1,234,255.77a9.9,9.9,0,0,1-.17-2.62,3,3,0,0,1,.17-1,18.91,18.91,0,0,0,.36,3.49,10.52,10.52,0,0,0,12.79,7.93A18.55,18.55,0,0,0,250.38,262.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.16,255.08a34.67,34.67,0,0,1-.27-8.39,33.37,33.37,0,0,1,.27,8.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.41,254.48a23.68,23.68,0,0,1,0-4.14,21.58,21.58,0,0,1,.24-4.13,13.2,13.2,0,0,1,.28,4.15A13,13,0,0,1,229.41,254.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.52,252.3s-.16.07-.5.14l-1.45.3c-1.26.26-3.1.57-5.38.9a147.85,147.85,0,0,1-35.92.73c-2.29-.24-4.14-.48-5.41-.68l-1.46-.24a1.8,1.8,0,0,1-.51-.12,1.86,1.86,0,0,1,.52,0l1.48.14c1.27.14,3.13.32,5.42.51a177.59,177.59,0,0,0,17.93.58,175,175,0,0,0,17.9-1.31c2.28-.28,4.13-.53,5.4-.73l1.47-.2A2.77,2.77,0,0,1,247.52,252.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.53,255a7.08,7.08,0,0,1-1.44,2.26,13.92,13.92,0,0,1-11.62,5,7.15,7.15,0,0,1-2.63-.53c0-.09,1,.14,2.65.16A14.93,14.93,0,0,0,196.81,257C197.93,255.84,198.45,255,198.53,255Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.19,278.83c-.15,0-.32-4.89-.38-10.91s0-10.92.14-10.92.31,4.88.38,10.91S223.33,278.83,223.19,278.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.05,302a39.79,39.79,0,0,1-.14-6.42,40.91,40.91,0,0,1,.38-6.41,39.79,39.79,0,0,1,.14,6.42A39.51,39.51,0,0,1,216.05,302Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,289.25a21.6,21.6,0,0,1-3.13.57c-1.94.31-4.62.74-7.56,1.28s-5.6,1.11-7.52,1.53a22.28,22.28,0,0,1-3.13.59,16.44,16.44,0,0,1,3-1c1.91-.51,4.56-1.13,7.51-1.68s5.65-.92,7.61-1.13A16.61,16.61,0,0,1,247,289.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,293.85a30.85,30.85,0,0,1-3.66.12c-2.26,0-5.38.11-8.82.29s-6.55.42-8.81.61a30.21,30.21,0,0,1-3.65.25,3.06,3.06,0,0,1,1-.22c.62-.12,1.53-.25,2.65-.39,2.25-.29,5.37-.6,8.82-.78s6.59-.18,8.85-.12c1.14,0,2,.07,2.68.11A3.39,3.39,0,0,1,249.9,293.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.7,290.85a19.63,19.63,0,0,1-2.58-1,62.43,62.43,0,0,0-6.27-2.21,61.54,61.54,0,0,0-6.47-1.48,19.18,19.18,0,0,1-2.72-.51,11,11,0,0,1,2.77.14,42.29,42.29,0,0,1,12.84,3.72A11.47,11.47,0,0,1,208.7,290.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.89,445.92l0,1.34s23.07,8.51,23.44,12.83l-45.29,1.07.26-15.09C277.15,449,284.2,449.22,291.89,445.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275,450.78a1.85,1.85,0,0,0-1.23,2.14,1.78,1.78,0,0,0,2.11,1.24,1.94,1.94,0,0,0,1.29-2.27,1.86,1.86,0,0,0-2.34-1.05",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.08,461.16l.06-3.63,43.38.3s2,.83,1.85,2.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.09,447.39c0,.22-1.1.34-2.17,1.08s-1.63,1.68-1.84,1.6.1-1.37,1.41-2.24S292.14,447.18,292.09,447.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.89,449.24c.06.21-.89.61-1.62,1.56s-.93,1.95-1.15,1.95-.39-1.25.54-2.42S296.88,449,296.89,449.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.72,454.86c-.2.05-.53-1.05,0-2.27s1.56-1.73,1.66-1.55-.53.85-1,1.86S299.94,454.83,299.72,454.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.56,451.06s-12,8.53-17.85,1.14l-1.52,3.59-6.84,25.51a3.42,3.42,0,0,0,1.93,4.09,3.31,3.31,0,0,0,3.5-.67c4.94-4.7,23.06-22.11,22.88-24.47l-.07-6.26a3.18,3.18,0,0,0-2-2.93Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.87,485.56l25.8-27.49v1.37c.13,1.49-.51,2.07-1.22,3-2.09,2.82-7.86,9.11-21.57,22.26a3.26,3.26,0,0,1-3,.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.89,454a2,2,0,0,0-.56,2.61,1.94,1.94,0,0,0,2.59.58,2.1,2.1,0,0,0,.57-2.77,2,2,0,0,0-2.75-.3",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.31,471.49c-.19.08-.91-1.61-2.83-2.53s-3.67-.52-3.71-.72.38-.33,1.14-.44a5.23,5.23,0,0,1,2.89.53,5,5,0,0,1,2.16,2C195.34,471,195.39,471.46,195.31,471.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,475.8c-.16.14-1.19-.91-2.86-1.4s-3.1-.22-3.15-.42,1.47-.84,3.36-.26S193.16,475.71,193,475.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.61,466c-.15.15-1.73-1.48-4.26-2.46s-4.78-.92-4.79-1.13,2.35-.62,5.05.47S199.77,465.87,199.61,466Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18,458.19c-.08.2-1.87-.55-4.19-.65s-4.16.46-4.23.26,1.77-1.1,4.27-1S200.29,458.05,200.18,458.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.67,457.47a2.85,2.85,0,0,1,.18-1.21,8.54,8.54,0,0,1,1.55-3,3.72,3.72,0,0,1,1.91-1.47,1.32,1.32,0,0,1,1.42.57,2.15,2.15,0,0,1,.24,1.52,4.68,4.68,0,0,1-4.83,3.5,5.42,5.42,0,0,1-4.71-3.77,1.83,1.83,0,0,1,.2-1.55,1.3,1.3,0,0,1,1.47-.43,4.65,4.65,0,0,1,1.88,1.48,9.35,9.35,0,0,1,1.71,2.87,2.89,2.89,0,0,1,.28,1.19,15.18,15.18,0,0,0-2.36-3.73,4.31,4.31,0,0,0-1.68-1.25.71.71,0,0,0-.8.23,1.28,1.28,0,0,0-.07,1,4.83,4.83,0,0,0,4.12,3.22,4,4,0,0,0,4.14-2.91,1.58,1.58,0,0,0-.11-1.07.71.71,0,0,0-.78-.32,3.35,3.35,0,0,0-1.65,1.21A12.83,12.83,0,0,0,194.67,457.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.33,162.06c-1.88-1.5-4.08-2.55-6-3.95s-3.76-5.09-4.21-7.46L209.69,152a60.56,60.56,0,0,0-2,18.71c.13,2.68.52,5.54,2.32,7.53,2,2.19,5.11,2.77,8,3.24l14.08,2.25c1.66.26,3.45.51,5-.22a6.59,6.59,0,0,0,3-3.75A15.92,15.92,0,0,0,235.33,162.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.3,175.87c-.82-4.57.06-9.22.48-13.79.62-6.66.26-13.54,0-20.36s-.52-13.71.37-20.28,3-12.83,6.57-16.36,8.71-3.74,12.27.6L196.59,123a503.65,503.65,0,0,1,.76,73.87,39,39,0,0,1-14.26.14,3,3,0,0,1-2.6-1.93c-.58-1.68.22-3.51.53-5.27a16.28,16.28,0,0,0-.75-7.14A64.74,64.74,0,0,1,178.3,175.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.4,107.14a12,12,0,0,1,5-3,4.08,4.08,0,0,1,2.34-.15,1.77,1.77,0,0,1,1.31,1.76l-4.62,6.54a3.18,3.18,0,0,1-3.51.16A3.27,3.27,0,0,1,190,110.4,3.78,3.78,0,0,1,191.4,107.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.16,170.09Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,126.05a18.34,18.34,0,0,0-18.55-16.8A17.81,17.81,0,0,0,189.89,128l3.42,40a3.44,3.44,0,0,0,.92,2.07,16.34,16.34,0,0,0,11.27,5.08,17.08,17.08,0,0,0,10.13-3.69,3.39,3.39,0,0,0,1.29-3.15L215.67,158h0a23.67,23.67,0,0,0,2.65-.5c2.26-.92,7.75-2.64,8-11.7A181.64,181.64,0,0,0,226,126.05Z",
    style: {
      fill: "#a57e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.81,140.92a10.62,10.62,0,0,1,2.53-.65c.4-.07.78-.18.83-.45a2.06,2.06,0,0,0-.37-1.16c-.45-.93-.93-1.91-1.44-2.93-2-4.17-3.48-7.62-3.31-7.69s1.93,3.24,3.94,7.41c.48,1,.94,2,1.39,3a2.31,2.31,0,0,1,.33,1.54,1,1,0,0,1-.62.63,2.84,2.84,0,0,1-.67.15A10.77,10.77,0,0,1,214.81,140.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,131.71a1.44,1.44,0,0,1-1.3,1.56,1.41,1.41,0,0,1-1.62-1.18,1.46,1.46,0,0,1,1.3-1.57A1.42,1.42,0,0,1,223,131.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.63,128.84c-.14.25-1.41-.57-3-.33s-2.56,1.36-2.77,1.15,0-.53.44-1a3.46,3.46,0,0,1,2.16-1.21,3.52,3.52,0,0,1,2.43.55C223.47,128.33,223.7,128.72,223.63,128.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.16,133.1a1.44,1.44,0,0,1-1.3,1.56,1.41,1.41,0,0,1-1.62-1.19,1.44,1.44,0,0,1,1.3-1.56A1.42,1.42,0,0,1,208.16,133.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.37,130.37c-.19.24-1.43-.75-3.14-.72s-2.94,1-3.13.77.09-.53.62-1a4,4,0,0,1,2.5-.91,4,4,0,0,1,2.51.87C208.27,129.85,208.46,130.27,208.37,130.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,158s-6.2,1-14.2-2.92c0,0,3.17,7.7,14.55,5.78Z",
    style: {
      fill: "#755246"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.45,144.71a2.94,2.94,0,0,0-2.64-.85,2.63,2.63,0,0,0-1.72,1.09,1.61,1.61,0,0,0,0,1.86,2,2,0,0,0,2.12.36,5.94,5.94,0,0,0,1.92-1.34,1.77,1.77,0,0,0,.42-.49.53.53,0,0,0,0-.58",
    style: {
      fill: "#755246"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.21,124.52c-.12.43-1.71.38-3.54.77s-3.28,1-3.56.67c-.13-.17.09-.59.65-1a6.08,6.08,0,0,1,2.58-1.17,6.3,6.3,0,0,1,2.84.06C208.88,124,209.26,124.31,209.21,124.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.23,125.43c-.31.37-1.62.06-3.19.11s-2.86.37-3.19,0c-.14-.18.05-.54.61-.9A5.07,5.07,0,0,1,220,124a5.12,5.12,0,0,1,2.58.59C223.17,124.89,223.37,125.25,223.23,125.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.52,107.06a5.39,5.39,0,0,0-4.38-1.7c-7.1,0-14.24,5.27-17.28,11.69s-2,15.17,1.81,21.17l2.67.08c5.38-1.12,12.3-17.56,18.69-27C210.83,110.1,209.41,108.16,208.52,107.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.48,109.68c-3.39-2.89-8.7-6.23-14.39-3.05-.64,1.82,1.47,3.75,3.15,4.81,2.46,1.56,4.55,2.54,6.18,3.68,3.3,2.29,7.55,6.25,8.56,11.19.07.31.14,10.05.44,9.95s1.21-12,1.3-14.79C227.9,115.56,225.87,112.56,222.48,109.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.61,134.88c-.18-.06-7-1.67-6.39,5.14s7.3,4.83,7.29,4.63S192.61,134.88,192.61,134.88Z",
    style: {
      fill: "#a57e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.21,142.25s-.11.09-.3.2a1.15,1.15,0,0,1-.89.09,2.94,2.94,0,0,1-1.58-2.51,3.92,3.92,0,0,1,.19-1.73,1.39,1.39,0,0,1,.82-1,.6.6,0,0,1,.72.27c.11.18.08.32.12.33s.13-.13.05-.4a.75.75,0,0,0-.3-.41.88.88,0,0,0-.67-.11,1.68,1.68,0,0,0-1.15,1.16,4.05,4.05,0,0,0-.25,1.93,3.08,3.08,0,0,0,2,2.79,1.25,1.25,0,0,0,1.07-.27C191.21,142.41,191.24,142.26,191.21,142.25Z",
    style: {
      fill: "#755246"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,110.86a7.48,7.48,0,0,1-1.94.51,28.26,28.26,0,0,1-9.65,0,6.79,6.79,0,0,1-1.94-.49,13.52,13.52,0,0,1,2,.2,43.22,43.22,0,0,0,4.78.26,41.4,41.4,0,0,0,4.78-.32A11.43,11.43,0,0,1,224,110.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.94,115.42a3.79,3.79,0,0,1-1.43.54,11.38,11.38,0,0,1-7.25-.65,3.83,3.83,0,0,1-1.31-.78,20.94,20.94,0,0,0,4.92,1.27A20.7,20.7,0,0,0,226.94,115.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.29,119.47c0-.09,1.49,0,3.85-.38a29.19,29.19,0,0,0,4.07-.94,38.5,38.5,0,0,0,4.75-1.9,42.32,42.32,0,0,0,4.44-2.55,37.89,37.89,0,0,0,3.34-2.53c1.81-1.54,2.8-2.66,2.85-2.6a5.08,5.08,0,0,1-.65.81,12,12,0,0,1-.83.9c-.34.34-.72.73-1.18,1.12a32.47,32.47,0,0,1-3.31,2.62,37.92,37.92,0,0,1-4.47,2.61,35,35,0,0,1-4.83,1.89,26.58,26.58,0,0,1-4.14.87,14.8,14.8,0,0,1-1.62.14,8.69,8.69,0,0,1-1.23,0A4.57,4.57,0,0,1,186.29,119.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.45,111a5.66,5.66,0,0,1-.43,1,10.34,10.34,0,0,1-.58,1.15c-.25.43-.5.95-.86,1.47a27.85,27.85,0,0,1-2.64,3.56,30.17,30.17,0,0,1-3.94,3.73,29.54,29.54,0,0,1-4.6,2.9,27.63,27.63,0,0,1-4.12,1.64c-.59.2-1.16.31-1.64.44s-.91.19-1.26.25a6.55,6.55,0,0,1-1.09.13c0-.09,1.53-.32,3.9-1.11a29.83,29.83,0,0,0,4-1.7,29.12,29.12,0,0,0,8.42-6.54,30.62,30.62,0,0,0,2.68-3.46C208.72,112.37,209.37,111,209.45,111Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.14,105.36a2.62,2.62,0,0,1,1.37-.08,5.93,5.93,0,0,1,3,1.4,4.92,4.92,0,0,1,.66.71,3.9,3.9,0,0,1,.44.78,9.53,9.53,0,0,1,.56,1.38,2,2,0,0,1,.07,1.37c-.07,0-.05-.52-.35-1.27a13.57,13.57,0,0,0-.63-1.3,3.8,3.8,0,0,0-.42-.71,5.22,5.22,0,0,0-.61-.64,6.45,6.45,0,0,0-2.78-1.42C204.66,105.4,204.15,105.43,204.14,105.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.12,135.65a1.21,1.21,0,0,0-.1-.35c-.07-.23-.19-.55-.32-1a30.76,30.76,0,0,1-1-3.65,26.07,26.07,0,0,1-.51-5.56,21.93,21.93,0,0,1,1.14-6.71,17.3,17.3,0,0,1,1.5-3.19,18.59,18.59,0,0,1,2-2.63,22.62,22.62,0,0,1,4.23-3.63,32.44,32.44,0,0,1,3.25-1.92l.92-.47a1.34,1.34,0,0,0,.31-.18l-.33.12c-.22.1-.55.22-.95.42a26.84,26.84,0,0,0-3.32,1.84,22.43,22.43,0,0,0-4.33,3.62,18.45,18.45,0,0,0-2,2.67,16.77,16.77,0,0,0-1.54,3.25,21.67,21.67,0,0,0-1.13,6.81,25.3,25.3,0,0,0,.58,5.6,25.64,25.64,0,0,0,1.06,3.65c.15.43.3.74.38,1A2.29,2.29,0,0,0,187.12,135.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.34,146.52c0-.21-1.55-.43-3.34-1.23s-3.06-2-3.16-1.81a6.08,6.08,0,0,0,3,2.46C213.69,146.78,215.33,146.69,215.34,146.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.07 164.48 216.29 163.32 193.16 166.31 181.35 172.89 201.87 181.54 216.8 178.48 226.07 164.48",
    style: {
      fill: "#a57e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.38,169,171,175.68l3.67,31.45s6.09-2.18,9.36,13.71,3.32,26.06,3.32,26.06l59.58-2.12s-2.17-38.09-3.26-46.58l-4-32.43L224.3,163.2S209.49,188.22,187.38,169Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.68,165.77s7.26-.52,13,9.52c4.36,7.64,5.9,10.59,5.9,10.59l-16.88,9.86-6.75-18.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.2,175.57s-6.53,3.7-10,8.49-7.62,13.58-7.62,13.58l20,11.12,3-5.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.79,202.49c-.09,0,.43-1.37.89-3.62a26.91,26.91,0,0,0,.53-4,30.56,30.56,0,0,0-.12-4.92,32.29,32.29,0,0,0-1-4.82,28.26,28.26,0,0,0-1.41-3.77c-1-2.08-1.76-3.27-1.68-3.32a3.61,3.61,0,0,1,.62.79,18.7,18.7,0,0,1,1.39,2.37,25,25,0,0,1,1.54,3.79,28.52,28.52,0,0,1,1,4.91,27.3,27.3,0,0,1,.09,5,23.89,23.89,0,0,1-.65,4,18.57,18.57,0,0,1-.82,2.62A3.29,3.29,0,0,1,176.79,202.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.82,181c-.16,0-.69-3.12-2.28-6.67a70.31,70.31,0,0,0-3.41-6.18,6.92,6.92,0,0,1,1.38,1.58,24.48,24.48,0,0,1,4.07,9.19A6.32,6.32,0,0,1,240.82,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,163.25a1.93,1.93,0,0,1-.16.51c-.14.32-.3.81-.6,1.4a23.91,23.91,0,0,1-3,4.74,26.43,26.43,0,0,1-6.13,5.61,25.9,25.9,0,0,1-27.32.65,24.08,24.08,0,0,1-4.49-3.35c-.49-.44-.82-.84-1.06-1.09s-.35-.4-.33-.41.54.49,1.53,1.35a26.43,26.43,0,0,0,4.53,3.18,26.89,26.89,0,0,0,7.66,2.86,25.11,25.11,0,0,0,19.21-3.59,27,27,0,0,0,6.11-5.44,26.57,26.57,0,0,0,3.08-4.6C228.66,163.91,229,163.24,229,163.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,199.79A158.39,158.39,0,0,1,194.36,167c-.67-7.85-2.72-14.18-3-21.91L186.89,153A216.1,216.1,0,0,0,182,183.22c-.29,3.19-.4,6.75,1.68,9.19,1.67,2,4.55,2.91,5.47,5.31,1,2.6-.46,6.44,2,7.74a3.26,3.26,0,0,0,3.73-.93,9.62,9.62,0,0,0,1.8-3.67c.23,2,2.57,4.12,4.09,2.77C201.73,202.72,201.41,201.09,201,199.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.27,291.09h0a16.17,16.17,0,0,0,22.42,8.19L326.54,183.06,355,141.82l-48.93,7.47L88.34,270.83A16.16,16.16,0,0,0,81.27,291.09Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.34,270.83a16.16,16.16,0,0,0-7.07,20.26h0a16.17,16.17,0,0,0,22.42,8.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "306.06 149.29 88.34 270.83 90.96 275.69 309.54 155.78 306.06 149.29"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.71 176.49 101.17 294.61 103.69 299.28 326.54 183.06 322.71 176.49"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "313.91 162.37 94.66 282.53 98.15 289.01 317.64 169.06 313.91 162.37"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "326.54 183.06 306.06 149.29 336.01 144.72 345.22 155.98 326.54 183.06",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.17,204l4-4.22s-.47-9.61,1.17-12l.85-1.42s-.85-4.67,1.66-5.75c.71-1.77,1.63-2.49,2.88-1.5,0,0-.7-3.52,2.58-4s4.22,14.42,4.22,14.42,1.64,6.68-2.11,6.68c0,0-2.11,2.34-4.46,2.58,0,0-.7,4-4,3.75Z",
    style: {
      fill: "#a57e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.46,197.07s.19.12.37.48a2.65,2.65,0,0,1,.19,1.65,3.69,3.69,0,0,1-1.23,2.13,7.45,7.45,0,0,1-2.62,1.43,18.48,18.48,0,0,1-5.22,1,6.32,6.32,0,0,1-2.2-.12,33.11,33.11,0,0,0,7.25-1.41,7.51,7.51,0,0,0,2.47-1.3,3.45,3.45,0,0,0,1.19-1.85A3.34,3.34,0,0,0,297.46,197.07Z",
    style: {
      fill: "#755246"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.37,191.78c-.16,0-.17-3-.88-6.58s-1.83-6.36-1.68-6.42a6.18,6.18,0,0,1,.87,1.76A26.77,26.77,0,0,1,300,185.1a28.48,28.48,0,0,1,.51,4.72A6.07,6.07,0,0,1,300.37,191.78Z",
    style: {
      fill: "#755246"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.54,193.42c-.15,0-.43-2.91-1.18-6.43s-1.66-6.32-1.52-6.37a22.48,22.48,0,0,1,2,6.26A22.81,22.81,0,0,1,297.54,193.42Z",
    style: {
      fill: "#755246"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.78,193.31c.12-.08.61.84.29,2s-1.2,1.72-1.26,1.59.51-.74.76-1.72S302.64,193.36,302.78,193.31Z",
    style: {
      fill: "#755246"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.62,194a19.64,19.64,0,0,1-.31-3.65,20.92,20.92,0,0,1-.15-3.66,9.7,9.7,0,0,1,.67,3.63A10.08,10.08,0,0,1,293.62,194Z",
    style: {
      fill: "#755246"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.56,197.64s-13.23,27.89-15.23,32.05-5.23,11.85,0,16.16S181,250.43,181,250.43l1.81-14.69-24-5.81,14.1-21.17Z",
    style: {
      fill: "#a57e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,236a12,12,0,0,1,3.16-4.16c2.29-2,7.33-3.54,8-5.45s2.56-.42,2.11,1.95c-.28,1.52-3.4,5.49-3.4,5.49s3.66.91,6.1-.49,11-3.93,11.88-2.73-1.21,1.79-2.16,2.34c-.73.41-6.4,3.22-6.4,3.22s11.28-.38,12.7.16,0,1.94-.75,2c-.44,0-2.38,1.75-3.75,3a5.1,5.1,0,0,1-3.42,1.38l-2.62,0,8,.84s1.37,1.26-.54,1.92c-.86.29-25,3.77-26.88,3.88-3.24.19-8.36,1-8.36,1l1.3-15Z",
    style: {
      fill: "#a57e6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.4,238.39A17.16,17.16,0,0,1,212,240a17.56,17.56,0,0,1-5.6.33c0-.15,2.49-.3,5.51-.84S217.35,238.25,217.4,238.39Z",
    style: {
      fill: "#755246"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.07,135.86l6.28-11.08a29.7,29.7,0,1,1,7.11,7.91h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.07,135.86l13.43-3,.18,0-.11-.15h0l-.17.16a29.66,29.66,0,0,0,14.24,6,26.87,26.87,0,0,0,4.7.24c.81,0,1.63-.06,2.47-.13l2.5-.38a29.76,29.76,0,0,0,23.24-36.6,29.15,29.15,0,0,0-6.37-12.22,29.84,29.84,0,0,0-11.44-8.17,30.37,30.37,0,0,0-13.32-2.05,29.24,29.24,0,0,0-12.22,3.62,30.15,30.15,0,0,0-14.09,17.35,32,32,0,0,0-1.29,9.66,29.54,29.54,0,0,0,4.45,14.72v-.12l-6.18,11.14,6.38-11,0-.06,0-.06a29.51,29.51,0,0,1-4.31-14.61,31.87,31.87,0,0,1,1.32-9.54A29.78,29.78,0,0,1,260.4,83.49a28.88,28.88,0,0,1,12-3.53,29.84,29.84,0,0,1,13.11,2,29.4,29.4,0,0,1,11.26,8,28.74,28.74,0,0,1,6.27,12,30,30,0,0,1,.36,13,29.55,29.55,0,0,1-13.35,19.2,29.73,29.73,0,0,1-9.86,3.91l-2.47.38c-.82.07-1.64.09-2.44.14a25.29,25.29,0,0,1-4.64-.22,29.46,29.46,0,0,1-14.14-5.86l-.74-.57.57.73v0l.07-.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.75 111.01 263.9 106.86 271.9 113.97 287.61 98.86 291.46 103 271.31 121.97 259.75 111.01",
    style: {
      fill: "#FF725E"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderDashboard);
export default __webpack_public_path__ + "static/media/reminder_dashboard.b862fc273f97b3fea01e2b287d24aeda.svg";
export { ForwardRef as ReactComponent };